import { InjectionToken } from '@angular/core';

import { SlnkMongoAbility } from '@app/models/api/v1/auth/ability.model';

export const SlnkAbility = new InjectionToken<SlnkMongoAbility>('SlnkAbility');
